// extracted by mini-css-extract-plugin
export default {"AboutQuestions_Container":"AboutQuestions_AboutQuestions_Container__1RLXx","Header":"AboutQuestions_Header__H-OG4"};